import { Component, Input } from '@angular/core'
import { Media } from '../../enums/enums'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-not-available',
  templateUrl: './ddc-not-available.component.html',
  styleUrl: './ddc-not-available.component.scss',
  imports: [DdcTextGradientComponent],
})
export class DdcNotAvailableComponent {
  @Input() _elem: string

  media_path = Media.MEDIA
  not_available_picture = 'not-available.png'
}
